module.exports = __webpack_public_path__ + "img/HistoryOutlined.5a2efadd.svg";